import type {
  V1alpha1Workspace,
  V1alpha1WorkspaceList
} from '@streamnative/cloud-api-client-typescript'
import { useComputeApi } from '@/api/cloudApi'

export const listWorkspaces = async (organization: string): Promise<V1alpha1Workspace[]> => {
  const result: V1alpha1WorkspaceList = (
    await useComputeApi().listNamespacedWorkspace(organization)
  ).data
  return result.items
}

export const createWorkspace = async (
  organization: string,
  body: V1alpha1Workspace
): Promise<V1alpha1Workspace> => {
  const result = await useComputeApi().createNamespacedWorkspace(organization, body)
  return result.data
}

export const getWorkspace = async (
  name: string,
  organization: string
): Promise<V1alpha1Workspace> => {
  const result = await useComputeApi().readNamespacedWorkspace(name, organization)
  return result.data
}

export const updateWorkspace = async (
  name: string,
  organization: string,
  body: V1alpha1Workspace
): Promise<V1alpha1Workspace> => {
  const result = await useComputeApi().replaceNamespacedWorkspace(name, organization, body)
  return result.data
}

export const deleteWorkspace = async (name: string, organization: string): Promise<void> => {
  await useComputeApi().deleteNamespacedWorkspace(name, organization)
}
